import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Subject } from 'rxjs';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {

  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  private frequency = 1000 * 60 * 2;
  private checkUrl: string | null = null;

  private _version = '';
  public get version() {
    return this._version;
  }
  public set version(value) {
    this._version = value;
  }

  getVersionFailedCounter = 0;
  public versionChanged = new Subject<string>();

  constructor(private http: HttpClient) {}

  /**
  * Checks in every set frequency the version of frontend application
  * @param frequency - in milliseconds, defaults to 2 minutes
  */
  public initVersionCheck(url: string, frequency = 1000 * 60 * 2) {
    this.frequency = frequency;
    this.checkUrl = url;
    this.checkVersion();
  }

  /**
  * Will do the call and check if the hash has changed or not
  */
  private checkVersion() {
      // timestamp these requests to invalidate caches
      this.http.get(this.checkUrl + '?t=' + new Date().getTime()).pipe(
        take(1)
      )
      .subscribe(
          (response: any) => {
            if (this._version === '') {
              this._version = response.version;
            }
            const version = response.version;
            const hash = response.hash;
            const hashChanged = this.hasHashChanged(hash, version);

            // If new version, do something
            if (hashChanged) {
              if (environment.production || environment.staging) {
                window.location.reload();
                //console.log(hash, this.currentHash, this.hasHashChanged);
                //this.versionChanged.next(this.version);
                //setTimeout(() => this.checkVersion(), this.frequency * 5);
              } else {
                setTimeout(() => this.checkVersion(), this.frequency);
              }
            } else {
              this.getVersionFailedCounter = 0;
              setTimeout(() => this.checkVersion(), this.frequency);
            }
          },
          (err) => {
              console.error(err, 'Could not get version');
              this.getVersionFailedCounter ++;
              if (this.getVersionFailedCounter > 2) {
                if (environment.production) {
                  window.location.reload();
                }
                //console.log('not found', this.currentHash);
              }
              setTimeout(() => this.checkVersion(), this.frequency);
          }
      );
  }

  private hasHashChanged(new_hash: string, version: string) {
    return this.currentHash !== new_hash; //this.version !== version;
  }
}
